/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var DiggIcon = createIcon({
  name: 'DiggIcon',
  height: 512,
  width: 512,
  svgPath: 'M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default DiggIcon;